export default "__VITE_ASSET__c9mf1wpa__"